import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid';

//actions:
import { modifyDatosCierreDiario, getArtGastosCentro, getTipogastosCierre } from '../../actions/cierre_diario_actions';
import { openDialog, hideDialog, setSaveState } from '../../actions/index';

//components:
import NeuriteGrid from '../../components/neurite_grid';
import FloatNumberFormatInput from '../../components/float_number_input_formatter';

//material ui components:
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

//helpers:
import { getData, postData } from '../../dataLib';

//grid de datos de facturas de MKT
//solo trabaja con state local ya que ningun otro control depende de estos datos
//y hace todas las modificaciones directamente en la DB cuando se hace click en OK

const styles = theme => ({
    total: {
        display: 'flex',
        fontWeight: '500',
        textTransform: 'capitalize',
        justifyContent: 'space-around',
        alignItems: 'center',
        width: 200,
        margin: '30px 8px 20px 0',
    },
    inputImporte: {
        textAlign: 'right',
        margin: 8,
        padding: 0,
        fontSize: 12,
    },
    input: {
        width: 80,
        height: 35,
        [`& fieldset`]: {
            borderRadius: 0,
            borderColor: 'black !important'
        },
        textAlign: 'right'
    },
    button: {
        margin: '15px 8px',
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    spinnerContainer: {
        width: '95%',
        height: 220,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
    divData: {
        position: 'relative'
    },
    cover: {
        position: 'absolute',
        height: 300,
        width: '100%',
        marginLeft: 8,
        zIndex: 1,
        backgroundColor: '#ddd',
        opacity: 0.3,
    },
});

class CierreDiarioGastosGrid extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            gastos: [],
            total: 0.00,
            showSpinner: true,
            saveDisabled: true
        };
    };

    componentDidUpdate(prevProps) {
        if (this.producto === undefined &&
            prevProps.centroDiaSelected !== this.props.centroDiaSelected) {
            this.getGastos();
            this.props.getArtGastosCentro(this.props.centroDiaSelected.centro.id);
            this.props.getTipogastosCierre();
        };
        if (prevProps.centroDiaSelected.dia !== this.props.centroDiaSelected.dia || prevProps.centroDiaSelected.centro !== this.props.centroDiaSelected.centro)
            this.setState({ ...this.state, showSpinner: true })
    };

    messageError = error => {

        this.props.openDialog('SimpleMessage', {
            message: error
        }, uuidv4(), false, 'sm');

    };

    checkValues = (gasto) => {

        if (!gasto.importe) {
            this.messageError('Por favor, defina un importe');
            return false;
        }
        else if(!gasto.observ){
            this.messageError('El campo observaciones no puede estar vacío.');
            return false;
        }

        return true;
    };

    modifyGasto = (gasto) => {
        var rows = this.state.gastos.map((row) => {
            if (row.id === gasto.id) return gasto;
            else return row;
        });
        this.props.setSaveState(true);
        this.setState({ ...this.state, gastos: rows, total: this.calculateTotal(rows), saveDisabled: false });
    };

    editGasto = (gasto) => {
        this.props.openDialog('EditGastosGrid', {
            gasto: gasto,
            producto: this.props.producto,
            zonas: this.props.artGastos.filter(tz => tz.id === this.props.producto.articuloId),
            conceptos: this.props.tipoGastosCierre,
            okHandler: this.modifyGasto,
            checkValues: this.checkValues,
            usuario: this.props.user ? this.props.user.profile.sub : 0,
            fecha: this.props.centroDiaSelected.dia
        }, uuidv4());
    };

    addGasto = (gasto) => {
        let rows = this.state.gastos.slice();
        rows.push(gasto);
        this.props.setSaveState(true);
        this.setState({ ...this.state, gastos: rows, total: this.calculateTotal(rows), saveDisabled: false });
    };

    //si venimos de cierre diario (existe this.props.producto) fijamos el tipo de zona (bar, bolera, ...)
    newGasto = () => {
        this.props.openDialog('EditGastosGrid', {
            gasto: {
                articuloId: this.props.producto ? this.props.producto.articuloId : '',
                tipoZona: this.props.producto ? this.props.artGastos.find(tz => tz.id === this.props.producto.articuloId).descr : ''
            },
            producto: this.props.producto,
            zonas: this.props.artGastos.filter(tz => tz.id === this.props.producto.articuloId),
            conceptos: this.props.tipoGastosCierre,
            okHandler: this.addGasto,
            checkValues: this.checkValues,
            usuario: this.props.user ? this.props.user.profile.sub : 0,
            fecha: this.props.centroDiaSelected.dia
        }, uuidv4());
    };


    deleteGasto = (factura) => {
        let rows = this.state.gastos.filter(f => f.id !== factura.id);
        this.props.setSaveState(true);
        this.setState({ ...this.state, gastos: rows, total: this.calculateTotal(rows), saveDisabled: false });
    };

    calculateTotal = (rows) => {
        let total = 0.0;
        rows.forEach((r) => {
            total += parseFloat(r.importe);
        });

        return total;
    };

    //obtiene los gastos de este articulo y dia
    getGastos = () => {

        let gastosURL = 'VGastos?date=' + this.props.centroDiaSelected.dia;

        if (this.props.producto !== undefined) gastosURL += '&articulo_id=' + this.props.producto.articuloId;
        else gastosURL += '&centro_id=' + this.props.centroDiaSelected.centro.id;

        getData(gastosURL,
            (response) => {
                this.setState({ ...this.state, gastos: response.data, total: this.calculateTotal(response.data), showSpinner: false });
            },
            (error) => {
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR fetching gastos'
                }, uuidv4(), false, 'sm');
            },
            this.props.user
        );
    };

    //hace un update de gastos
    updateGastos = () => {

        this.setState({ ...this.state, saveDisabled: true });

        var gastos = this.state.gastos.slice();
        gastos.forEach((f) => {
            if (typeof f.id !== 'number') f.id = -1;
        });

        let gastosURL = 'VGastos/gastos?date=' + this.props.centroDiaSelected.dia;
        if (this.props.producto !== undefined) gastosURL += '&articulo_id=' + this.props.producto.articuloId;
        else gastosURL += '&centro_id=' + this.props.centroDiaSelected.centro.id;

        postData(gastosURL,
            () => {
                this.props.hideDialog();
                this.props.openDialog('SimpleMessage', {
                    message: 'gastos actualizados'
                }, uuidv4(), false, 'sm');
                this.props.setSaveState(false);
                if (this.props.producto !== undefined) this.props.modifyDatosCierreDiario({ ...this.props.producto, importe: -1.0 * this.state.total })
            },
            () => {
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR updating gastos'
                }, uuidv4(), false, 'sm');
            },
            gastos,
            this.props.user
        );

    };

    componentDidMount = () => {

        let centroId = -1;
        if (this.props.producto !== undefined) centroId = this.props.producto.centroId;
        else centroId = this.props.centroDiaSelected.centro.id;

        this.getGastos();
        this.props.getArtGastosCentro(centroId);
        this.props.getTipogastosCierre();
    };

    deshacer = () => {
        this.setState({ ...this.state, showSpinner: true })
        this.getGastos();
    }


    render() {
        const { classes } = this.props;

        if (this.state.showSpinner)
            return (
                <div className={classes.spinnerContainer}>
                    <CircularProgress className={classes.spinner} color="primary" />
                </div>
            );

        return (
            <div className={classes.divData}>
                <div className={classes.cover} style={{ display: this.props.centroDiaSelected.isValid ? 'none' : 'block' }} ></div>
                <NeuriteGrid
                    id="c_d_g_g"
                    columns={[
                        { key: 'tipoZona', name: 'Zona', editable: false, dragable: false, width: 70},
                        { key: 'tipoArticulo', name: 'Articulo', tooltip:'Artículo de gasto', editable: false, dragable: false, width: 300 },
                        { key: 'importe', name: 'Importe', tooltip:'Importe con IVA  incluido', editable: false, dragable: false, type: 'float', width: 70 },
                        { key: 'observ', name: 'Observ', editable: false, dragable: false, width: 350 },
                    ]}
                    rows={this.state.gastos}
                    buttonEdit={!this.props.isDiaCerrado}
                    buttonDelete={!this.props.isDiaCerrado}
                    buttonNew={!this.props.isDiaCerrado && this.props.centroDiaSelected.isValid}
                    onNewRowClick={this.newGasto}
                    onEditClick={this.editGasto}
                    onDeleteClick={this.deleteGasto}
                    enableSelection={false}
                    height={300}
                />

                <div className={classes.total}>
                    <p style={{ margin: 0 }}>Total</p>

                    <TextField
                        id="total"
                        disabled
                        value={this.state.total}
                        variant="outlined"
                        className={classes.input}
                        InputProps={{ classes: { input: classes.inputImporte }, inputComponent: FloatNumberFormatInput }}
                    />
                </div>

                <div>
                    {this.props.isDialog ?
                        <Button variant="contained" color="secondary" className={classes.button} disabled={!this.props.centroDiaSelected.isValid} onClick={() => { this.props.hideDialog() }}>Cerrar</Button>
                        :
                        <Button hidden={this.props.isDiaCerrado} variant="contained" color="secondary" className={classes.button} disabled={!this.props.centroDiaSelected.isValid} onClick={() => { this.deshacer() }}>Deshacer</Button>
                    }
                    {!this.props.isDiaCerrado ? <Button variant="contained" color="primary" className={classes.button} disabled={!this.props.centroDiaSelected.isValid || this.state.saveDisabled} onClick={() => { this.updateGastos() }}>Guardar</Button> : ''}
                </div>
            </div>
        );
    };
};


CierreDiarioGastosGrid.propTypes = {
    //state
    user: PropTypes.object,
    centroDiaSelected: PropTypes.object.isRequired,
    isDiaCerrado: PropTypes.object.isRequired,
    artGastos: PropTypes.object.isRequired,
    tipoGastosCierre: PropTypes.object.isRequired,
    //dispatch
    modifyDatosCierreDiario: PropTypes.func.isRequired,
    getArtGastosCentro: PropTypes.func.isRequired,
    getTipogastosCierre: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    //parameters
    producto: PropTypes.object,

};

function mapStateToProps(state) {
    return {
        centroDiaSelected: state.centroDiaSelected,
        artGastos: state.artGastos,
        tipoGastosCierre: state.tipoGastosCierre,
        isDiaCerrado: state.centroDiaSelected.isDiaCerrado,
        user: state.oidc.user
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        modifyDatosCierreDiario,
        hideDialog,
        openDialog,
        getArtGastosCentro,
        getTipogastosCierre,
        setSaveState
    }, dispatch);
};


export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(CierreDiarioGastosGrid));